var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Config } from './../../config/config';
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';
import { getBrokerId, getToken } from './authentication';
import { api } from './server';
import { SubmissionRouteType, } from '../models';
var getpath = function (servicepath) {
    return sessionStorage.getItem('baseUrl') + servicepath;
};
export var services = {
    getBroker: function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).getNoNull;
                    _d = (_c = "".concat(getpath(Config.accountService), "broker/get/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent()])])];
            }
        });
    }); },
    getLoanPurposes: function () {
        return api.get("".concat(getpath(Config.lookupService), "list/getlist/loanpurchase"));
    },
    getTitles: function () {
        return api.get("".concat(getpath(Config.lookupService), "list/getlist/Title"));
    },
    getjobTitles: function () {
        return api.get("".concat(getpath(Config.lookupService), "list/getlist/JobTitle"));
    },
    getList: function (listType) {
        return api.get("".concat(getpath(Config.lookupService), "list/getlist/").concat(listType));
    },
    getWorkflowSteps: function (loanPurposeId) {
        return api.get("".concat(getpath(Config.productService), "workflow/GetDynamicWorkflow/").concat(loanPurposeId));
    },
    getDynamicWorkflow: function (applicationId, loanPurposeId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetDynamicWorkflow/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(loanPurposeId)])];
            }
        });
    }); },
    getWorkflowCompletionStatus: function (applicantId) {
        return api.get("".concat(getpath(Config.productService), "workflow/WorkflowCompletionStatus?applicantId=").concat(applicantId));
    },
    getPagesWithStatus: function (applicationId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetPages/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId)])];
            }
        });
    }); },
    getCustomer: function (customerId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.accountService), "customer/get/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(customerId)])];
            }
        });
    }); },
    getPages: function (formId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, api.get("".concat(getpath(Config.productService), "workflow/getPages/").concat(formId, "/false"))];
        });
    }); },
    getAllUsers: function (pageNumber, pageSize, sort, sortOrder) {
        return api.get("".concat(getpath(Config.accountService), "user/GetAll/").concat(pageNumber, "/").concat(pageSize, "/").concat(sort, "/").concat(sortOrder));
    },
    getUserStatuses: function () {
        return api.get("".concat(getpath(Config.accountService), "user/GetUserStatuses"));
    },
    getAllCustomers: function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.accountService), "customer/GetAll/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent()])])];
            }
        });
    }); },
    search: function (searchText, pageNumber, pageSize, sort, sortOrder) {
        if (searchText === void 0) { searchText = ' '; }
        if (pageNumber === void 0) { pageNumber = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        if (sort === void 0) { sort = 'id'; }
        if (sortOrder === void 0) { sortOrder = 'desc'; }
        return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _b = (_a = api).get;
                        _d = (_c = "".concat(getpath(Config.accountService), "customer/Search/")).concat;
                        return [4 /*yield*/, getBrokerId()];
                    case 1: 
                    //Call for mock
                    // api.get<CustomerInterface[]>(`${Config.accountService}customer/Search/${testBrokerId}`),
                    return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(searchText.trim().length > 0 ? searchText.trim() : ' ', "/").concat(pageNumber, "/").concat(pageSize, "/").concat(sort, "/").concat(sortOrder)])];
                }
            });
        });
    },
    startApplication: function (customerId, loanPurposeId, selectedApplicants, selectedSubmissionRoute) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "application/save/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent()]), JSON.stringify({
                            customerId: parseInt(customerId),
                            loanPurposeId: loanPurposeId,
                            applicants: selectedApplicants.map(function (a) { return ({ customerId: a.id }); }),
                            mortgageclub: selectedSubmissionRoute != null && selectedSubmissionRoute.type === SubmissionRouteType.MortgageClub
                                ? {
                                    mortgageClubId: selectedSubmissionRoute.id,
                                }
                                : null,
                            network: selectedSubmissionRoute != null && selectedSubmissionRoute.type === SubmissionRouteType.Network
                                ? {
                                    networkId: selectedSubmissionRoute.id,
                                }
                                : null,
                        })])];
            }
        });
    }); },
    saveAddress: function (address) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, api.post("".concat(getpath(Config.accountService), "address/address"), JSON.stringify(address))];
    }); }); },
    saveAddressList: function (address) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, api.post("".concat(getpath(Config.accountService), "address/SaveAddressList"), JSON.stringify(address))];
    }); }); },
    getAddress: function (addressId) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).get;
                _d = (_c = "".concat(getpath(Config.accountService), "address/GetAddressByGuid/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(addressId)])];
        }
    }); }); },
    getAddressList: function (searchBy, searchFilter) {
        return api.get("".concat(getpath(Config.lookupService), "AddressLookup/GetAddressList/").concat(searchFilter, "/").concat(searchBy));
    },
    getAddressDetail: function (searchBy, searchFilter) {
        return api.get("".concat(getpath(Config.lookupService), "AddressLookup/GetAddressList/").concat(searchFilter, "/").concat(searchBy));
    },
    getMaxApplicants: function () {
        return api.get("".concat(getpath(Config.lookupService), "systemrule/getvalue/APP-NUMBER"));
    },
    getMortgageClubs: function () { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).get;
                _d = (_c = "".concat(getpath(Config.accountService), "mortgageclub/getorganisations/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent()])])];
        }
    }); }); },
    getNetworks: function () { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).get;
                _d = (_c = "".concat(getpath(Config.accountService), "network/getnetworks/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent()])])];
        }
    }); }); },
    getFees: function (caseId, formId) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).get;
                _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetFees/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(caseId, "/").concat(formId)])];
        }
    }); }); },
    savePaidFees: function (caseId, formId, fee) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/SavePaidFees/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(caseId, "/").concat(formId), JSON.stringify(fee)])];
            }
        });
    }); },
    saveFee: function (caseId, formId, fee) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/SaveFees/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(caseId, "/").concat(formId), JSON.stringify(fee)])];
            }
        });
    }); },
    updateUserStatus: function (userId, statusId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, api.post("".concat(getpath(Config.accountService), "User/UpdateStatus/").concat(userId, "/").concat(statusId), JSON.stringify(userId))];
    }); }); },
    removeFee: function (caseId, formId, loanToValueId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).delete;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/DeleteFee/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(caseId, "/").concat(formId, "/").concat(loanToValueId)])];
            }
        });
    }); },
    removePaidFee: function (caseId, formId, feeId, productId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).delete;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/DeletePaidFee/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(caseId, "/").concat(formId, "/").concat(feeId, "/").concat(productId)])];
            }
        });
    }); },
    saveClient: function (customer) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).post;
                _d = (_c = "".concat(getpath(Config.accountService), "Customer/Save/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent()]), JSON.stringify(customer)])];
        }
    }); }); },
    removeClient: function (customerId) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).delete;
                _d = (_c = "".concat(getpath(Config.accountService), "Customer/Delete/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(customerId)])];
        }
    }); }); },
    UpdateBroker: function (broker) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).post;
                _d = (_c = "".concat(getpath(Config.accountService), "Broker/Update/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent()]), JSON.stringify(broker)])];
        }
    }); }); },
    saveSectionAnswers: function (applicationId, formId, answers, isAdmin) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/SaveSection/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId, "/").concat(isAdmin), JSON.stringify(answers)])];
            }
        });
    }); },
    getQuestionSets: function (caseId, sectionId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetSection/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(caseId, "/").concat(sectionId, "/").concat(formId)])];
            }
        });
    }); },
    getDynamicProductList: function (caseId, formId, loanPurposeId, loanAmount, purchasePrice, loanTerm, loanTermMon) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetDynamicProductList/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(caseId, "/").concat(formId, "/").concat(loanPurposeId, "/").concat(loanAmount, "/").concat(purchasePrice, "/").concat(loanTerm, "/").concat(loanTermMon)])];
            }
        });
    }); },
    getApplicationAnswers: function (caseId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetApplicationAnswers/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(caseId, "/").concat(formId)])];
            }
        });
    }); },
    getCase: function (caseId) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).get;
                _d = (_c = "".concat(getpath(Config.applicationService), "Application/Get/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(caseId)])];
        }
    }); }); },
    getCaseDetails: function (caseId) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).get;
                _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetDetails/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(caseId)])];
        }
    }); }); },
    submitCase: function (applicationId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/SubmitCase/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId), JSON.stringify({})])];
            }
        });
    }); },
    getCustomerDocuments: function (customerId) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).get;
                _d = (_c = "".concat(getpath(Config.accountService), "Customer/GetDocuments/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(customerId)])];
        }
    }); }); },
    getCustomerDocument: function (documentId) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).getAsBlob;
                _d = (_c = "".concat(getpath(Config.accountService), "Customer/GetDocument/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(documentId)])];
        }
    }); }); },
    deleteCustomerDocument: function (documentId) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).delete;
                _d = (_c = "".concat(getpath(Config.accountService), "Customer/DeleteDocument/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(documentId)])];
        }
    }); }); },
    getThemeUrl: function () { return api.getAsBlob("".concat(getpath(Config.lookupService), "Config/GetTheme")); },
    getTenant: function () { return __awaiter(void 0, void 0, void 0, function () {
        var tenant, request, _a, _b, _c, data, answer;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    tenant = sessionStorage.getItem('Tenant');
                    if (!tenant) return [3 /*break*/, 1];
                    return [2 /*return*/, tenant];
                case 1:
                    _a = Request.bind;
                    _b = [void 0, "".concat(getpath(Config.lookupService), "config/GetTenant")];
                    _d = {};
                    _e = {
                        'Content-Type': 'application/json'
                    };
                    _c = "Bearer ".concat;
                    return [4 /*yield*/, getToken()];
                case 2:
                    request = new (_a.apply(Request, _b.concat([(_d.headers = (_e.authorization = _c.apply("Bearer ", [_f.sent()]),
                            _e['Content-Security-Policy'] = " default-src 'self'",
                            _e),
                            _d)])))();
                    return [4 /*yield*/, fetch(request)];
                case 3:
                    data = _f.sent();
                    return [4 /*yield*/, data.text()];
                case 4:
                    answer = _f.sent();
                    //handle developer mode where there wil be no ingress header
                    if (answer === 'NoTenant') {
                        if (Config.developermode === 'true') {
                            sessionStorage.setItem('Tenant', 'MutualVision');
                            return [2 /*return*/, 'MutualVision'];
                        }
                        else {
                            sessionStorage.setItem('Tenant', answer);
                            return [2 /*return*/, answer];
                        }
                    }
                    else {
                        sessionStorage.setItem('Tenant', answer);
                        return [2 /*return*/, answer];
                    }
                    _f.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); },
    getLogoUrl: function () {
        return "".concat(getpath(Config.lookupService), "Config/GetLogo");
    },
    uploadDocument: function (customerDocument) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.accountService), "Customer/UploadDocument/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent()]), JSON.stringify(customerDocument)])];
            }
        });
    }); },
    logError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, api.post("".concat(getpath(Config.accountService), "Error/LogError"), JSON.stringify(err))];
        });
    }); },
    getModuleText: function (code) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, api.get("".concat(getpath(Config.lookupService), "ModuleText/GetByCode/").concat(code))];
        });
    }); },
    getModuleTextNullable: function (code) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, api.getNoNull("".concat(getpath(Config.lookupService), "ModuleText/GetByCode/").concat(code))];
        });
    }); },
    GetDecrypt: function (cipherText) {
        return api.getNoNull("".concat(getpath(Config.lookupService), "Config/GetDecrypt/").concat(cipherText));
    },
    getSystemRule: function (code) {
        return api.getNoNull("".concat(Config.lookupService, "systemrule/getvalue/").concat(code), true);
    },
    submitApplication: function (applicationId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/Submit/").concat(applicationId, "/").concat(formId, "/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent()]), null])];
            }
        });
    }); },
    getMandatoryDocuments: function () {
        return api.get("".concat(getpath(Config.lookupService), "systemrule/GetByRuleCode/MANDATORY_DOCUMENTS"));
    },
    getProductCategories: function () { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).get;
                _d = (_c = "".concat(getpath(Config.productService), "product/GetProductCategories/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent()])])];
        }
    }); }); },
    getProducts: function (categoryId, isFixed, searchText, pageNumber, pageSize, sort, sortOrder) {
        if (isFixed === void 0) { isFixed = 0; }
        if (searchText === void 0) { searchText = ' '; }
        if (pageNumber === void 0) { pageNumber = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        if (sort === void 0) { sort = 'description'; }
        if (sortOrder === void 0) { sortOrder = 'Asc'; }
        return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _b = (_a = api).get;
                        _d = (_c = "".concat(getpath(Config.productService), "product/GetProducts/")).concat;
                        return [4 /*yield*/, getBrokerId()];
                    case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(categoryId, "/").concat(searchText.trim().length > 0 ? searchText.trim() : ' ', "/").concat(isFixed, "/").concat(pageNumber, "/").concat(pageSize, "/").concat(sort, "/").concat(sortOrder)])];
                }
            });
        });
    },
    getAllProductDetails: function (productId, loanPurposeId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.productService), "product/GetAllProductDetails/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(productId, "/").concat(loanPurposeId, "/").concat(true, "/").concat(true, "/").concat(true, "/").concat(true, "/").concat(true, "/").concat(true)])];
            }
        });
    }); },
    getAutoDeclineAnswers: function (formSectionId) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).get;
                _d = (_c = "".concat(getpath(Config.productService), "workflow/GetAutoDeclineAnswers/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(formSectionId)])];
        }
    }); }); },
    getDeclarations: function (applicationId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetDeclarations/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId)])];
            }
        });
    }); },
    getDeclarationDocumentUrl: function () {
        return "".concat(getpath(Config.productService), "Workflow/GetDeclarationDocument/");
    },
    isDipCertificateAvailable: function (applicationId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/IsDipCertificateAvailable/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId)])];
            }
        });
    }); },
    getEsisDocumentId: function (applicationId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetEsisDocumentId/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId)])];
            }
        });
    }); },
    getDownloadForm: function (applicationId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).getAsBlob;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/DownloadPdfForm/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId)])];
            }
        });
    }); },
    getDownloadCertificate: function (applicationId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).getAsBlob;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/DownloadDipCertificate/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId)])];
            }
        });
    }); },
    getDownloadDeclarationDocument: function (declarationDocumentId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, api.getAsBlob("".concat(getpath(Config.productService), "Workflow/GetDeclarationDocument/").concat(declarationDocumentId))];
    }); }); },
    getDownloadDocument: function (documentId) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).getAsBlob;
                _d = (_c = "".concat(getpath(Config.applicationService), "Case/GetDocument/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(documentId)])];
        }
    }); }); },
    getDownloadIllustration: function (esisDocumentId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).getAsBlob;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/DownloadEsisDocument/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(esisDocumentId, "/")])];
            }
        });
    }); },
    getNotificationsUrl: function () {
        return "".concat(getpath(Config.applicationService), "notificationshub");
    },
    getHubConnection: function () {
        return new HubConnectionBuilder()
            .withUrl(services.getNotificationsUrl(), {
            accessTokenFactory: function () { return getToken(); },
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets,
        })
            .withAutomaticReconnect()
            .build();
    },
    submitWorldPayOrder: function (applicationId, formId, worldPayOrder) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/SubmitOrder/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId), JSON.stringify(worldPayOrder)])];
            }
        });
    }); },
    worldPayOrderResponse: function (uniqueOrderCode, applicationFeeSummaryId, worldPayOrderResponse) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/WorldPayOrderResponse/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(uniqueOrderCode, "/").concat(applicationFeeSummaryId).concat(worldPayOrderResponse)])];
            }
        });
    }); },
    isWorldPayProviderActive: function () {
        return api.get("".concat(getpath(Config.applicationService), "Application/IsWorldPayProviderActive"));
    },
    saveDeclarations: function (applicationId, formId, documentDeclarationIds) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/SaveDeclarationDocuments/").concat(applicationId, "/").concat(formId, "/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent()]), JSON.stringify(documentDeclarationIds)])];
            }
        });
    }); },
    getCaseSummary: function (searchText, pageNumber, pageSize, sort, sortOrder, customerId) {
        if (searchText === void 0) { searchText = ' '; }
        if (pageNumber === void 0) { pageNumber = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        if (sort === void 0) { sort = 'id'; }
        if (sortOrder === void 0) { sortOrder = 'desc'; }
        if (customerId === void 0) { customerId = 0; }
        return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _b = (_a = api).get;
                        _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetCaseSummary/")).concat;
                        return [4 /*yield*/, getBrokerId()];
                    case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(searchText.trim().length > 0 ? searchText.trim() : ' ', "/").concat(pageNumber, "/").concat(pageSize, "/").concat(sort, "/").concat(sortOrder, "/").concat(customerId)])];
                }
            });
        });
    },
    getNotes: function (applicationId) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).get;
                _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetNotes/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId)])];
        }
    }); }); },
    saveNote: function (applicationId, customerId, text) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/SaveNote/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId), JSON.stringify({
                            id: 0,
                            customerId: customerId,
                            text: text,
                            formattedCreated: '',
                            advisorId: 0,
                            adminId: 0,
                            adminOnly: false,
                            canBeDeleted: false,
                            applicationId: applicationId,
                        })])];
            }
        });
    }); },
    cancelCase: function (applicationId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/CancelCase/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId), JSON.stringify({})])];
            }
        });
    }); },
    UpdateDocumentPageViewed: function (applicationId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/UpdateDocumentPageViewed/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId), JSON.stringify({})])];
            }
        });
    }); },
    getCaseTracking: function (applicationId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Case/GetStages/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId)])];
            }
        });
    }); },
    getPaidFees: function (caseId) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).get;
                _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetPaidFees/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(caseId)])];
        }
    }); }); },
    getEsisSummary: function (applicationId, formId, sort, sortOrder) {
        if (sort === void 0) { sort = 'description'; }
        if (sortOrder === void 0) { sortOrder = 'Asc'; }
        return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _b = (_a = api).getNoNull;
                        _d = (_c = "".concat(getpath(Config.applicationService), "Application/GetEsisSummary/")).concat;
                        return [4 /*yield*/, getBrokerId()];
                    case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId, "/").concat(sort, "/").concat(sortOrder)])];
                }
            });
        });
    },
    uploadStageDocument: function (document, applicationStageComponentId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "CaseStageDocument/UploadDocument/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationStageComponentId), JSON.stringify(document)])];
            }
        });
    }); },
    UpdateFeePageViewed: function (applicationId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/UpdateFeePageViewed/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId), JSON.stringify({})])];
            }
        });
    }); },
    declineCase: function (applicationId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).post;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/DeclineCase/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(applicationId, "/").concat(formId), JSON.stringify({})])];
            }
        });
    }); },
    isClientHaveSubmittedForm: function (customerId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = api).get;
                    _d = (_c = "".concat(getpath(Config.applicationService), "Application/")).concat;
                    return [4 /*yield*/, getBrokerId()];
                case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/"]).concat(customerId, "/IsClientHaveSubmittedForm")])];
            }
        });
    }); },
    getWebConfigValue: function (key, productId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, api.get("".concat(getpath(Config.lookupService), "config/getvalue/").concat(key, "/").concat(productId))];
    }); }); },
    getCustomerTypes: function () { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d; return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = api).get;
                _d = (_c = "".concat(getpath(Config.applicationService), "Application/")).concat;
                return [4 /*yield*/, getBrokerId()];
            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [_e.sent(), "/GetCustomerTypes"])])];
        }
    }); }); },
};
